/* Paintly Kits: What's inside your kit, W18 Lavender v2 (approved 5 Oct 2026). Built by build_theme.py from the
   prototype (wfl.js + chap.js). The film starts loading about one screen away and plays once it is well in view; it
   pauses when scrolled away and carries on when back. The part on screen sets the card and the marked number; tapping
   a number jumps there. Reduced motion: the film never plays; tapping a number shows that part settled, as a still
   (data-still seconds into the part). */
(function () {
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function watch(el, fn, opt) {
    if (!('IntersectionObserver' in window)) { fn(true, null); return; }
    var o = new IntersectionObserver(function (es) { es.forEach(function (e) { fn(e.isIntersecting, o); }); }, opt); o.observe(el);
  }
  function boot(root) {
    if (!root || root.getAttribute('data-pklv')) return; root.setAttribute('data-pklv', '1');
    var v = root.querySelector('.pklv-v'), card = root.querySelector('.pklv-card');
    var B = [].slice.call(root.querySelectorAll('.pklv-dot'));
    if (!v || !card || !B.length) return;
    var no = card.querySelector('.pklv-no'), name = card.querySelector('.pklv-name'), line = card.querySelector('.pklv-line');
    var CH = B.map(function (b) { return { t: parseFloat(b.getAttribute('data-t')) || 0, n: b.getAttribute('data-n'), s: b.getAttribute('data-s') }; });
    var stillAt = parseFloat(root.getAttribute('data-still')) || 0;
    var cur = -1, loaded = false, seen = false;
    function at(t) { var i = 0; CH.forEach(function (c, j) { if (t >= c.t) i = j; }); return i; }
    function end(i) { return i < CH.length - 1 ? CH[i + 1].t : (v.duration || CH[CH.length - 1].t + 5); }
    function setChap(i) {
      if (i === cur) return; var first = cur < 0; cur = i;
      B.forEach(function (b, j) { b.setAttribute('aria-current', String(j === i)); });
      no.textContent = '0' + (i + 1); name.textContent = CH[i].n; line.textContent = CH[i].s;
      if (!first) { card.classList.remove('sw'); void card.offsetWidth; card.classList.add('sw'); }
    }
    function tick() {
      var t = v.currentTime, i = at(t);
      setChap(i);
      B.forEach(function (b, j) { var f = j === i ? (t - CH[j].t) / (end(j) - CH[j].t) : 0; var s = b.querySelector('s'); if (s) s.style.width = (100 * Math.max(0, Math.min(1, f))).toFixed(1) + '%'; });
    }
    function load() {
      if (loaded) return; loaded = true;
      [].forEach.call(v.querySelectorAll('source[data-src]'), function (s) { s.setAttribute('src', s.getAttribute('data-src')); s.removeAttribute('data-src'); });
      v.preload = 'auto'; v.load();
    }
    function play() { if (reduce) return; load(); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    v.addEventListener('timeupdate', tick); v.addEventListener('seeked', tick);
    B.forEach(function (b, i) {
      b.addEventListener('click', function () {
        load(); setChap(i);
        // reduced motion: show that part settled, as a still; otherwise jump to it and play
        var go = function () {
          v.currentTime = reduce ? CH[i].t + (stillAt ? Math.min(stillAt, end(i) - CH[i].t - .35) : Math.min(2.2, (end(i) - CH[i].t) / 2)) : CH[i].t + (i ? .3 : 0);
          tick(); play();
        };
        if (v.readyState >= 1) go(); else v.addEventListener('loadedmetadata', go, { once: true });
      });
    });
    setChap(0);
    watch(root, function (on, o) { if (on) { load(); if (o) o.disconnect(); } }, { rootMargin: '900px 0px' });
    watch(v, function (on) {
      if (on) { seen = true; play(); }
      else if (seen && !v.paused) v.pause();
    }, { threshold: .45 });
  }
  function all() { [].forEach.call(document.querySelectorAll('.pklv'), boot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target && e.target.querySelector && e.target.querySelector('.pklv')); });
})();
